import { PurchaseOrderItem } from '@/models/PurchaseOrderItem';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<EditPurchaseOrderItemDialog>({})
export default class EditPurchaseOrderItemDialog extends Vue {
  // #region @Props

  @Prop()
  protected purchaseOrderItemOriginal!: PurchaseOrderItem;

  protected purchaseOrderItem: PurchaseOrderItem = this.purchaseOrderItemOriginal;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected isLoading = false;

  protected isPurchaseOrderItemFormValid = false;

  // #endregion

  // #region Lifecycle Hooks / Init

  protected mounted(): void {
    this.purchaseOrderItem = this.purchaseOrderItemOriginal;
  }

  // #endregion

  // #region Handlers

  protected onClose(): void {
    this.$emit('input', false);
  }

  protected async onUpdate(): Promise<void> {
    this.isLoading = true;

    await this.update();

    this.isLoading = false;
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region Async methods

  protected async update(): Promise<void> {
    try {
      this.purchaseOrderItem = await this.purchaseOrderItem
        .update(this.purchaseOrderItem);

      this.$emit('updated');
    } catch (error) {
      ErrorHandler.network(error);
    }
  }

  protected get canUpdate(): boolean {
    if (!this.purchaseOrderItem) { return false; }

    return this.isPurchaseOrderItemFormValid;
  }

  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
